
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import './Error.css';

function Error(props) {

  return (
    <>
    <Header />
    <div className="iol-checkout-body row">
      <div className="iol-checkout-left-part col-xl-7">
        <div className="iol-checkout-left">
          <div className="caption fucsia-text semibold">{props.title && props.title}{!props.title && "Opss qualcosa non va"}</div>
          <div className="checkout-data-title semibold errDesc">{props.desc && props.desc}{!props.desc && <>Ci sono problemi a completare la tua richiesta, o il tuo carrello contiene prodotti che non puoi acquistare. Contatta il servizio clienti al numero <a href="tel:800011411" rel="noopener"><strong>800 011 411</strong></a></>}</div>
        </div>
      </div>
    </div>
    <Footer pageTitle="Pagina di errore"/>
    </>
  );
}

export default Error;
